import ReactDOM from 'react-dom/client';
import './scss/styles.scss';
import App from './App';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <App />
);

